import { FundMyAccountResponse, SupportedCurrencies, FundingSource } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export type FundMyAccount = {
  Token: string;
  Currency: SupportedCurrencies;
  ClientAccountID?: string;
  Amount: number;
  ClientReferenceNumber?: string;
  Notes?: string;
  Source?: Exclude<FundingSource, 'balance'>;
};

export default function useFundMyAccount() {
  const [fetching, setFetching] = useState(false);

  async function fundMyAccount(params: FundMyAccount): Promise<FundMyAccountResponse> {
    try {
      setFetching(true);
      const res = await api.postFundMyAccount({
        Amount: params.Amount || 0,
        Currency: params.Currency,
        ClientReferenceNumber: params.ClientReferenceNumber,
        Notes: params.Notes,
        ClientAccountID: params.ClientAccountID,
        Source: params.Source,
      });

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fundMyAccount };
}
